import React from 'react';
import { InputNumber, Select, Space, Switch } from 'antd';
import { EASING_TYPES } from 'util/constants';
import styles from '../../../event-timeline.module.css';

const { Option } = Select;

interface RotateParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const RotateParams: React.FC<RotateParamsProps> = ({ params, setParams }) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <div>
          <h3>Rotate Continuously:</h3>
          <Switch
            value={params.infinite || false}
            onChange={(value) => setParams({ ...params, infinite: value })}
          />
        </div>
        {params.infinite && (
          <>
            <h3>Rotate X:</h3>
            <Switch
              value={params.rotateInfiniteX || false}
              onChange={(value) =>
                setParams({ ...params, rotateInfiniteX: value })
              }
            />
            <h3>Rotate Y:</h3>
            <Switch
              value={params.rotateInfiniteY || false}
              onChange={(value) =>
                setParams({ ...params, rotateInfiniteY: value })
              }
            />
            <h3>Rotate :</h3>
            <Switch
              value={params.rotateInfiniteZ || false}
              onChange={(value) =>
                setParams({ ...params, rotateInfiniteZ: value })
              }
            />
          </>
        )}
        {!params.infinite && (
          <>
            <span className={styles.label}>Rotation X in deg:</span>
            <InputNumber
              value={params.rotation?.x || 0}
              onChange={(value) =>
                setParams({
                  ...params,
                  rotation: {
                    ...params.rotation,
                    x: value,
                  },
                })
              }
              style={{ width: '100%' }}
            />
            <span className={styles.label}>Rotation Y in deg:</span>
            <InputNumber
              value={params.rotation?.y || 0}
              onChange={(value) =>
                setParams({
                  ...params,
                  rotation: {
                    ...params.rotation,
                    y: value,
                  },
                })
              }
              style={{ width: '100%' }}
            />
            <span className={styles.label}>Rotation Z in deg:</span>
            <InputNumber
              value={params.rotation?.z || 0}
              onChange={(value) =>
                setParams({
                  ...params,
                  rotation: {
                    ...params.rotation,
                    z: value,
                  },
                })
              }
              style={{ width: '100%' }}
            />
            <span className={styles.label}>Easing:</span>
            <Select
              value={params.easing || 'linear'}
              onChange={(value) => setParams({ ...params, easing: value })}
              style={{ width: '100%' }}
            >
              <Option value={EASING_TYPES.LINEAR}>Linear</Option>
              <Option value={EASING_TYPES.EASE_IN}>Ease In</Option>
              <Option value={EASING_TYPES.EASE_OUT}>Ease Out</Option>
              <Option value={EASING_TYPES.EASE_IN_OUT}>Ease In Out</Option>
            </Select>
            <Space direction='vertical'>
              <span className={styles.label}>Duration (ms):</span>
              <InputNumber
                value={params.duration || 0}
                onChange={(value) => {
                  setParams({
                    ...params,
                    duration: value,
                  });
                }}
                min={0}
                style={{ width: '100%' }}
              />
            </Space>
          </>
        )}
      </Space>
    </div>
  );
};

export default RotateParams;
